namespace RioERP.Masters {
    export interface WhatsAppTemplateVariablesForm {
        VariableCode: Serenity.StringEditor;
        VariableName: Serenity.StringEditor;
    }

    export class WhatsAppTemplateVariablesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.WhatsAppTemplateVariables';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhatsAppTemplateVariablesForm.init)  {
                WhatsAppTemplateVariablesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(WhatsAppTemplateVariablesForm, [
                    'VariableCode', w0,
                    'VariableName', w0
                ]);
            }
        }
    }
}
